import { render, staticRenderFns } from "./list_child_comment.vue?vue&type=template&id=b6c7aee2&scoped=true&"
import script from "./list_child_comment.vue?vue&type=script&lang=js&"
export * from "./list_child_comment.vue?vue&type=script&lang=js&"
import style0 from "./list_child_comment.vue?vue&type=style&index=0&id=b6c7aee2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c7aee2",
  null
  
)

export default component.exports